import { NgModule } from '@angular/core';
import { RouterModule, Routes, provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
//+==================================== GLOBAL ====================================+\\
import { Unauthorized401Component } from './Components/Global/Errors/unauthorized401/unauthorized401.component';
import { CloseSessionComponent } from './Components/Global/Errors/close-session/close-session.component';
import { LoginCDMSComponent } from './Components/Global/login-cdms/login-cdms.component';
import { DashboardComponent } from "./Components/Global/dashboard/dashboard.component";
import { SearchDocsApiComponent } from './Components/Global/search-docs-api/search-docs-api.component';

import { guardTokenGuard } from './Guards/Token/guard-token.guard';
import { libraryGuard } from './Guards/Library/library.guard';
import { NotLibraryComponent } from './Components/Global/Errors/not-library/not-library.component';

//+==================================== CONTENT ====================================+\\

const routes: Routes = [

  { path: 'Docs', component: SearchDocsApiComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  //+============ GLOBAL ============+\\
  { path: 'LoginCDMS/:Key', component: LoginCDMSComponent },
  {
    path: 'Dashboard', component: DashboardComponent, children: [

      //+============ CONTENT ============+\\

      //-============ ADMINISTRATOR ============-\\
      { path: 'Admin', loadChildren: () => import('./Routes/Admin/admin-routing.module').then(m => m.AdminRoutingModule) },

      //-============ GLOBAL COMPONENTS ============-\\
      { path: 'General', loadChildren: () => import('./Routes/Global-Components/global-components-routing.module').then(m => m.GlobalComponentsRoutingModule) },

      //-============ LIBRARY CCP (DEPRECATED - Moved to Lib/hoe) ============-\\
      //{ path: 'CCP', loadChildren: () => import('./Routes/Libraries/Library-CCP/library-ccp-routing.module').then(m => m.LibraryCCPRoutingModule) },


      //-============ LIBRARY FIN ============-\\
      { path: 'FIN', loadChildren: () => import('./Routes/Libraries/Library-FIN/library-fin-routing.module').then(m => m.LibraryFINRoutingModule) },


      //-============ DYNAMIC LIBRARIES ============-\\
      { path: 'Lib/:libSlug', canActivate: [libraryGuard], loadChildren: () => import('./Routes/Libraries/Library-Master/library-master.module').then(m => m.LibraryMasterModule) },



      { path: '**', redirectTo: '/Dashboard/General/HomeSystemCDMS' }

    ], canActivate: [guardTokenGuard]
  },

  { path: 'DashboardAdmin', loadChildren: () => import('./Routes/Admin/dradmin/dradmin-routing.module').then(m => m.DRAdminRoutingModule) },
  
  { path: 'Unauthorized401', component: Unauthorized401Component },
  { path: 'CloseSessionUse', component: CloseSessionComponent },
  { path: 'NotRelatLibrary', component: NotLibraryComponent },

  { path: '**', pathMatch: 'full', redirectTo: 'LoginCDMS/Home' },



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
    )
  ]
})
export class AppRoutingModule { }
